// Globals
import { TFunction } from 'react-i18next';
import { ColumnsType } from 'antd/es/table';
import Link from 'antd/es/typography/Link';

// Components
import { StyledBadge, StyledBadgeWrapper, StyledDownloadButton } from './GeneratedQrListStyles';
import { DownloadIcon } from '@/icons';
import { TextTruncate, Tooltip } from '@/ui';

// Models
import { IGeneratedQrItem } from '@/models/generateQr.model';

// Modules
import { getImportStatusLabel } from '@/modules/ProductsImport';

// Helpers
import { formatDate } from '@/utils';
import { getCategoriesRow, getStoresPartnersRow, getStoresRow, getPartnersRow } from '../../helpers';

type TGetTableColumns = {
  t: TFunction;
};

export const getGeneratedQRTableColumns = ({ t }: TGetTableColumns): ColumnsType<IGeneratedQrItem> => [
  {
    title: t('imports_list_date'),
    dataIndex: 'created_at',
    key: 'created_at',
    render: (created_at) => <span>{created_at ? formatDate(created_at) : '-'}</span>,
  },
  {
    title: t('imports_list_partner'),
    dataIndex: 'partners',
    key: 'partners',
    render: (partners) => (
      <span>
        <Tooltip title={getPartnersRow(partners)}>
          <TextTruncate text={getStoresPartnersRow(partners)} rows={1} style={{ width: 250 }} />
        </Tooltip>
      </span>
    ),
  },
  {
    title: t('generate_qr_list_category'),
    dataIndex: 'categories',
    key: 'categories',
    render: (categories) => {
      return (
        <span>
          <Tooltip title={getCategoriesRow(categories)}>
            <TextTruncate text={getStoresRow(categories)} rows={1} style={{ width: 250 }} />
          </Tooltip>
        </span>
      );
    },
  },
  {
    title: t('imports_list_status'),
    dataIndex: 'status',
    key: 'status',
    render: (status) => (
      <StyledBadgeWrapper>
        <StyledBadge $status={status}>
          <div className="indicator" />
          <span>{getImportStatusLabel(status, t)}</span>
        </StyledBadge>
      </StyledBadgeWrapper>
    ),
  },
  {
    title: t('imports_list_error_file'),
    dataIndex: 'errors_file',
    key: 'errors_file',
    render: (errors_file) => {
      return errors_file ? (
        <StyledDownloadButton href={errors_file} rel="noreferrer">
          <DownloadIcon />
          {t('imports_list_download_error_file')}
        </StyledDownloadButton>
      ) : (
        '-'
      );
    },
  },
  {
    title: t('imports_list_download'),
    dataIndex: 'result_file',
    key: 'result_file',
    render: (result_file) => {
      return result_file ? (
        <Link href={result_file} target="_blank" rel="noreferrer">
          <StyledDownloadButton>
            <DownloadIcon />
            {t('imports_list_download')}
          </StyledDownloadButton>
        </Link>
      ) : (
        '-'
      );
    },
  },
];
